import { render, staticRenderFns } from "./FinalProductTableMobile.vue?vue&type=template&id=e25f7d90&scoped=true&lang=pug"
import script from "./FinalProductTableMobile.vue?vue&type=script&lang=js"
export * from "./FinalProductTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25f7d90",
  null
  
)

export default component.exports